import classNames from 'classnames';
import Loader from '../Loader';

function FullScreenLoader({ isTransparent = false }) {
  return (
    <div
      className={classNames(
        'pos-fixed tl-top-0 tl-left-0 ht-100p wd-100p z-index-200 tx-white d-flex align-items-center justify-content-center',
        {
          'bg-black-2': isTransparent,
          'bg-white': !isTransparent,
        }
      )}
      style={{ zIndex: 9999 }}
    >
      <Loader className="tl-color-6d4175" />
    </div>
  );
}

export default FullScreenLoader;
